export default "__VITE_ASSET__CLZ4UJAn__"